const list = [
    'Personne seule',
    '2 personnes sans personne à charge<br>(hors jeune ménage)',
    '3 personnes<br>ou personne seule + 1 personne à charge<br>ou jeune ménage',
    '4 personnes<br>ou personne seule + 2 personnes à charge',
    '5 personnes<br>ou personne seule + 3 personnes à charge',
    '6 personnes<br>ou personne seule + 4 personnes à charge',
    'Par personne supplémentaire',
];

const frm = document.querySelector('#frm_plafonds');
if ( frm ) {
    const container = document.querySelector('#zone_plafonds');
    const input = document.querySelector('#textarea_plafonds');
    let value = JSON.parse(input.value);

    const prefix = 'tabs-plafonds';
    let indexSelected = 0;

    const zones = {
        'A bis': Array(list.length).fill(''),
        'A': Array(list.length).fill(''),
        'B1': Array(list.length).fill(''),
        'B2': Array(list.length).fill(''),
        'C': Array(list.length).fill(''),
    }
    const types = {
        'PLUS': JSON.parse(JSON.stringify(zones)),
        'PLS accession': JSON.parse(JSON.stringify(zones)),
        'LI accession': JSON.parse(JSON.stringify(zones)),
        'PSLA': JSON.parse(JSON.stringify(zones)),
        'BRS': JSON.parse(JSON.stringify(zones)),
    }
    
    function changeValue(index, val, type, zone, cat) {
        value[index]['plafonds'][type][zone][cat] = val;
        input.value = JSON.stringify(value);
    }

    function renderTabs() {
        const wrapper = document.createElement('div');
        if ( value.length ) {
            const tabs = document.createElement('ul');
            tabs.classList.add('nav', 'nav-tabs');
            value.forEach((el, index) => {
                const li = document.createElement('li');
                li.classList.add('nav-items');
                const a = document.createElement('a');
                a.id = prefix + index + 'tab';
                a.classList.add('nav-link');
                if ( index == indexSelected ) {
                    a.classList.add('active');
                }
                a.dataset.toggle = 'tab';
                a.href = '#' + prefix + index + 'pane';
                const span = document.createElement('span');
                span.textContent = el.annee;
                a.appendChild(span);
                const close = document.createElement('button');
                close.type = 'button';
                close.classList.add('close', 'ml-2');
                close.innerHTML = '<span>&times;</span>';
                close.addEventListener('click', e => {
                    value.splice(index, 1);
                    input.value = JSON.stringify(value);
                    renderTabs();
                });
                a.appendChild(close);
                li.appendChild(a);
                tabs.appendChild(li);
            });
            wrapper.appendChild(tabs);

            const panes = document.createElement('div');
            panes.classList.add('tab-content');
            value.forEach((el, index) => {
                const pane = document.createElement('div');
                pane.id = prefix + index + 'pane';
                pane.classList.add('tab-pane', 'fade', 'py-3');
                if ( index == indexSelected ) {
                    pane.classList.add('show', 'active');
                }
                const div = document.createElement('div');
                div.classList.add('form-row', 'align-items-baseline', 'mb-3');
                const col1 = document.createElement('div');
                col1.classList.add('col-auto');
                col1.innerHTML = '<label>Année :</label>';
                div.appendChild(col1);
                const col2 = document.createElement('div');
                col2.classList.add('col');
                const inputAnnee = document.createElement('input');
                inputAnnee.type = 'number';
                inputAnnee.classList.add('form-control');
                inputAnnee.value = el.annee;
                inputAnnee.style.maxWidth = '100px';
                inputAnnee.addEventListener('input', e => {
                    value[index].annee = e.target.value;
                    input.value = JSON.stringify(value);
                    container.querySelector('.nav-tabs li:nth-child(' + (index + 1) + ') .nav-link span').textContent = e.target.value;
                });
                col2.appendChild(inputAnnee);
                div.appendChild(col2);
                pane.appendChild(div);

                let table;
                let thead;
                let tr;
                let th;
                let tbody;
                let td;
                for ( const type in types ) {
                    table = document.createElement('table');
                    table.classList.add('table', 'table-sm', 'table-bordered', 'table-striped', 'mb-4');
                    thead = document.createElement('thead');
                    tr = document.createElement('tr');
                    th = document.createElement('th');
                    th.setAttribute('rowspan', 2);
                    th.textContent = 'Catégorie de ménage';
                    tr.appendChild(th);
                    th = document.createElement('th');
                    th.classList.add('text-center', 'table-info');
                    th.setAttribute('colspan', Object.keys(zones).length);
                    th.textContent = type;
                    tr.appendChild(th);
                    thead.appendChild(tr);
                    tr = document.createElement('tr');
                    for ( const zone in zones ) {
                        th = document.createElement('th');
                        th.classList.add('text-center');
                        th.textContent = 'Zone ' + zone;
                        tr.appendChild(th);
                    }
                    thead.appendChild(tr);
                    table.appendChild(thead);
                    tbody = document.createElement('tbody');
                    for ( let i = 0; i < list.length; i++ ) {
                        tr = document.createElement('tr');
                        td = document.createElement('td');
                        td.innerHTML = list[i];
                        tr.appendChild(td);
                        for ( const zone in zones ) {
                            td = document.createElement('td');
                            let input = document.createElement('input');
                            input.type = 'number';
                            input.classList.add('form-control', 'form-control-sm');
                            input.value = value[index]['plafonds'][type][zone][i];
                            input.addEventListener('input', e => {
                                changeValue(index, e.target.value, type, zone, i);
                            });
                            td.appendChild(input);
                            tr.appendChild(td);
                        }
                        tbody.appendChild(tr);
                    }
                    table.appendChild(tbody);
                    pane.appendChild(table);
                }
                panes.appendChild(pane);
            });
            wrapper.appendChild(panes);
        }

        container.replaceChildren();
        container.appendChild(wrapper);
    }

    document.querySelector('#add_plafonds_annee').addEventListener('click', e => {
        e.preventDefault();
        value.push({
            annee: new Date().getFullYear(),
            plafonds: JSON.parse(JSON.stringify(types)),
        });
        input.value = JSON.stringify(value);
        indexSelected = value.length - 1;
        renderTabs();
    });

    renderTabs();
    
}

document.querySelectorAll('.auto_plafonds').forEach(autoPlafonds => {
    const container = autoPlafonds.closest('.tab-pane');
    const msg = autoPlafonds.querySelector('.msg');
    const id = container.id.match(/^client_lot_(\d+)$/)[1];
    const selectAnnee = autoPlafonds.querySelector('.auto_plafonds_annee');
    const selectZone = autoPlafonds.querySelector('.auto_plafonds_zone');
    const btn = autoPlafonds.querySelector('.btn');
    const inputRevenu = document.querySelector('#frm_client_' + id + '_revenu_fiscal_reference_n2');
    const inputPersonnes = document.querySelector('#frm_client_' + id + '_nombre_personnes');
    const inputEnfants = document.querySelector('#frm_client_' + id + '_nombre_enfants');
    const inputPlafondPLUS = document.querySelector('#frm_client_' + id + '_montant_plafond');
    const inputPlafondPSLA = document.querySelector('#frm_client_' + id + '_montant_plafond_psla');
    const inputPlafondBRS = document.querySelector('#frm_client_' + id + '_montant_plafond_brs');
    const checkboxPSLA = document.querySelector('#frm_client_' + id + '_data_psla');
    const checkboxPLUS = document.querySelector('#frm_client_' + id + '_data_plus');
    const checkboxPLS = document.querySelector('#frm_client_' + id + '_data_pls');
    const checkboxPLIInf = document.querySelector('#frm_client_' + id + '_data_pli_inf');
    const checkboxPLISup = document.querySelector('#frm_client_' + id + '_data_pli_sup');
    const checkboxJeuneMenage = document.querySelector('#frm_client_' + id + '_data_jeune_menage');

    const plafonds = JSON.parse(autoPlafonds.querySelector('textarea').value);

    selectAnnee.addEventListener('change', e => {
        btn.disabled = selectAnnee.value == '' || selectZone.value == '';
    });
    selectZone.addEventListener('change', e => {
        btn.disabled = selectAnnee.value == '' || selectZone.value == '';
    });

    btn.addEventListener('click', e => {
        e.preventDefault();
        msg.innerHTML = '';

        const annee = selectAnnee.value;
        const zone = selectZone.value;
        const revenu = parseInt(inputRevenu.value.replace(' ', ''));
        const personnes = parseInt(inputPersonnes.value.replace(' ', ''));
        let enfants = parseInt(inputEnfants.value.replace(' ', ''));
        const jeuneMenage = checkboxJeuneMenage.checked;
        
        if ( isNaN(revenu) ) {
            msg.innerHTML = '<span class="text-danger">Revenu fiscal de référence n-2 incorrect</span>';
            return false;
        }
        if ( isNaN(personnes) ) {
            msg.innerHTML = '<span class="text-danger">Nombre de personnes qui vivront dans le logement incorrect</span>';
            return false;
        }
        if ( isNaN(enfants) ) {
            enfants = 0;
        }

        let category = false;
        let personnesSupplementaires = 0;

        if ( personnes > 6 ) {
            category = 5;
            personnesSupplementaires = personnes - 6; 
        } else if ( (personnes == 6) || (personnes == 5 && enfants == 4) ) {
            category = 5
        } else if ( (personnes == 5) || (personnes == 4 && enfants == 3) ) {
            category = 4;
        } else if ( (personnes == 4) || (personnes == 3 && enfants == 2) ) {
            category = 3;
        } else if ( (personnes == 3) || (personnes == 2 && enfants == 1) || jeuneMenage ) {
            category = 2;
        } else if ( personnes == 2 && enfants == 0 && !jeuneMenage ) {
            category = 1;
        } else if ( personnes == 1 && enfants == 0 ) {
            category = 0;
        }

        if ( category === false ) {
            msg.innerHTML = '<span class="text-danger">Catégorie de ménage impossible à déternimer</span>';
            return false;
        }

        let text = '<div>' + list[category] + '</div>';
        if ( personnesSupplementaires > 0 ) {
            text += '<div>+' + personnesSupplementaires + ' personne' + (personnesSupplementaires > 1 ? 's' : '') + ' supplémentaire' + (personnesSupplementaires > 1 ? 's' : '') + '</div>';
        }

        let plafondPLUS = plafonds[annee]['PLUS'][zone][category];
        let plafondPLS = plafonds[annee]['PLS accession'][zone][category];
        let plafondLI = plafonds[annee]['LI accession'][zone][category];
        let plafondPSLA = plafonds[annee]['PSLA'][zone][category];
        let plafondBRS = plafonds[annee]['BRS'][zone][category];

        text += '<div>Plafond PLUS : ' + prixFormat(plafondPLUS) + '</div>';
        text += '<div>Plafond PLS accession : ' + prixFormat(plafondPLS) + '</div>';
        text += '<div>Plafond LI accession : ' + prixFormat(plafondLI) + '</div>';
        text += '<div>Plafond PSLA : ' + prixFormat(plafondPSLA) + '</div>';
        text += '<div>Plafond BRS : ' + prixFormat(plafondBRS) + '</div>';

        inputPlafondPLUS.value = prixFormat(plafondPLUS);
        inputPlafondPSLA.value = prixFormat(plafondPSLA);
        inputPlafondBRS.value = prixFormat(plafondBRS);

        checkboxPSLA.checked = revenu <= plafondPSLA;
        if ( revenu <= plafondPSLA ) {
            text += '<div>&lt; PSLA</div>';
        }
        checkboxPLUS.checked = revenu <= plafondPLUS;
        if ( revenu <= plafondPLUS ) {
            text += '<div>&lt; PLUS</div>';
        }
        checkboxPLS.checked = revenu <= plafondPLS;
        if ( revenu <= plafondPLS ) {
            text += '<div>&lt; PLS</div>';
        }
        checkboxPLIInf.checked = revenu <= plafondLI;
        if ( revenu <= plafondLI ) {
            text += '<div>&lt; PLI</div>';
        }
        checkboxPLISup.checked = revenu > plafondLI;
        if ( revenu > plafondLI ) {
            text += '<div>&rt; PLI</div>';
        }

        msg.innerHTML = text;
    });
});

